import { DecennialCertificateColumns } from "@dune/types";
import { ColumnDef } from "@tanstack/react-table";
import { format } from "date-fns";

export const getCertificateForContractorColumns =
	(): ColumnDef<DecennialCertificateColumns>[] => [
		{
			accessorKey: "validityStartDate",
			header: "Année",
			cell: ({ row }) => {
				const cert = row.original;
				const year = cert.validityStartDate
					? format(cert.validityStartDate, "yyyy")
					: "Non renseigné";

				return <span className="text-gray-900">{year}</span>;
			},
		},
		{
			accessorKey: "insurerSociety.society.denomination",
			header: "Assureur",
			cell: ({ row }) => {
				const cert = row.original;
				return cert.insurerSociety?.society?.denomination || "Non renseigné";
			},
		},
		{
			accessorKey: "validityStartDate",
			header: "Début de validité",
			cell: ({ row }) => {
				const cert = row.original;
				return cert.validityStartDate
					? format(cert.validityStartDate, "dd/MM/yyyy")
					: "Non renseigné";
			},
		},
		{
			accessorKey: "validityEndDate",
			header: "Fin de validité",
			cell: ({ row }) => {
				const cert = row.original;
				return cert.validityEndDate
					? format(cert.validityEndDate, "dd/MM/yyyy")
					: "Non renseigné";
			},
		},
		{
			accessorKey: "activities",
			header: "Activités couvertes",
			cell: ({ row }) => {
				const cert = row.original;
				return Array.isArray(cert.activities)
					? cert.activities.join(", ")
					: cert.activities || "Non renseigné";
			},
		},
	];

export const certificateForContractorColumns =
	getCertificateForContractorColumns();
